import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { RadioGroup as ChakraRadioGroup, } from '@chakra-ui/react';
import { RadioGroupContext } from './useRadioGroupWithOthers';
/**
 * Container for a group of radio buttons.
 */
export const RadioGroup = ({ onChange, children, ...props }) => {
    const othersRadioRef = useRef(null);
    const othersInputRef = useRef(null);
    return (_jsx(RadioGroupContext.Provider, { value: {
            othersRadioRef,
            othersInputRef,
        }, children: _jsx(ChakraRadioGroup, { ...props, onChange: onChange, children: children }) }));
};
